export default {"src":"/_next/static/media/cut.db305e35.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};